import { createContext, useContext } from "react";
import { CartContextValue } from "./use-provide-cart";

export const CartContext = createContext<CartContextValue | undefined>(
  undefined,
);

export function useCart(): CartContextValue {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}
